import React from 'react'
import xss from 'xss'
import { BrandIconId } from './BrandIconId.type'
import { BrandIconColor } from './BrandIconColor.type'
import { BrandIconSize } from './BrandIconSize.type'
import { pascalCase } from '@ampcore/string-format'
import './style.module.scss'

declare global {
  interface Window {
    AMPCOMPATH: string
  }
}

export const BRAND_ICON_SPRITE_PATH =
  'images/brand-icons/icon-sprite-2025-11-12.svg'

export type BrandIconProps = {
  icon: BrandIconId
  color?: BrandIconColor
  size?: BrandIconSize
  fill?: boolean
  stroke?: boolean
  className?: string
  style?: React.CSSProperties
  ariaLabel?: string
  spriteUrl?: string
  testId?: string
}

export const BrandIcon = (props: BrandIconProps) => {
  const {
    icon,
    size,
    fill,
    stroke,
    style,
    className,
    ariaLabel,
    spriteUrl,
    testId
  } = props
  let { color } = props
  const classList = ['BrandIcon']

  const hasClassColor = (classColor: string): classColor is BrandIconColor => {
    return Object.values(BrandIconColor).includes(classColor as BrandIconColor)
  }

  if (!color && className && hasClassColor(className)) {
    color = className
  }

  if (className && !hasClassColor(className)) {
    classList.push(className)
  }

  if (color) {
    const colorPascalCase = pascalCase(color)
    if (fill) {
      classList.push(
        colorPascalCase == 'AmpfBlue'
          ? `u-fill${colorPascalCase}`
          : `u-fillColor${colorPascalCase}`
      )
    } else if (stroke) {
      classList.push(
        colorPascalCase == 'AmpfBlue'
          ? `u-stroke${colorPascalCase}`
          : `u-strokeColor${colorPascalCase}`
      )
    } else {
      classList.push(`u-bgColor${colorPascalCase} u-fillColorWhite`)
    }
  }

  switch (size) {
    case BrandIconSize.SMALL:
      classList.push('BrandIcon--sizeSmall')
      break
    case BrandIconSize.LARGE:
      classList.push('BrandIcon--sizeLarge')
      break
    case BrandIconSize.MEDIUM:
      classList.push('BrandIcon--sizeMedium')
      break
    case BrandIconSize.DEFAULT:
      classList.push('BrandIcon--sizeDefault')
      break
    default:
      break
  }

  const spriteHref = () => {
    if (spriteUrl === '') {
      return `#${icon}`
    }
    if (spriteUrl) {
      return `${spriteUrl}#${icon}`
    }

    const basePath = window.AMPCOMPATH

    return `${basePath}${BRAND_ICON_SPRITE_PATH}#${icon}`
  }

  if (icon === BrandIconId.NONE) {
    return null
  }

  return (
    <svg
      className={classList.join(' ')}
      aria-hidden={ariaLabel ? undefined : 'true'}
      aria-label={ariaLabel}
      preserveAspectRatio="xMinYMin meet"
      style={style}
      data-testid={testId ? `${testId}-svg` : null}
    >
      <use
        href={xss(spriteHref())}
        data-testid={testId ? `${testId}-svg-use` : null}
      />
    </svg>
  )
}
